import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('academy-common-lib');